<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M5.12999 13.6H8.87999C9.10011 13.6 9.31123 13.6874 9.46688 13.8431C9.62254 13.9988 9.70999 14.2099 9.70999 14.43C9.70999 14.6501 9.62254 14.8612 9.46688 15.0169C9.31123 15.1726 9.10011 15.26 8.87999 15.26H1.93999C1.71986 15.26 1.50874 15.1726 1.35309 15.0169C1.19743 14.8612 1.10999 14.6501 1.10999 14.43C1.10999 14.2099 1.19743 13.9988 1.35309 13.8431C1.50874 13.6874 1.71986 13.6 1.93999 13.6H2.50999C2.32999 13.22 2.21999 12.8 2.21999 12.35V5.27C2.21999 4.46109 2.54132 3.68531 3.11331 3.11333C3.6853 2.54134 4.46107 2.22 5.26999 2.22H14.71C15.5189 2.22 16.2947 2.54134 16.8667 3.11333C17.4386 3.68531 17.76 4.46109 17.76 5.27V5.55C17.76 5.77013 17.6725 5.98124 17.5169 6.1369C17.3612 6.29255 17.1501 6.38 16.93 6.38C16.7099 6.38 16.4987 6.29255 16.3431 6.1369C16.1874 5.98124 16.1 5.77013 16.1 5.55V5.27C16.1 4.51 15.47 3.89 14.71 3.89H5.26999C4.49999 3.88 3.87999 4.51 3.87999 5.27V12.35C3.87999 13.04 4.43999 13.6 5.12999 13.6Z"
            fill="#8E8E93"
        />
        <path
            d="M16.37 7.76999H13.6C11.9333 7.76999 11.1 8.60332 11.1 10.27V16.37C11.1 18.0367 11.9333 18.87 13.6 18.87H16.37C18.0367 18.87 18.87 18.0367 18.87 16.37V10.27C18.87 8.60332 18.0367 7.76999 16.37 7.76999Z"
            fill="#8E8E93"
        />
    </svg>
</template>
